export default {
  首页: "Startseite",
  资产: "Vermögen",
  币币: "Spot",
  快捷买币: "Schnell Krypto kaufen",
  "支持多种方式购买，购买更简单":
    "Kaufen Sie einfach mit verschiedenen Zahlungsmethoden",
  语言设置: "Spracheinstellungen",
  确认恢复: "Wiederherstellung bestaetigen",
  "输入邮箱，方便我们联系您":
    "Geben Sie Ihre E-Mail-Adresse ein, damit wir Sie kontaktieren koennen",
  划转: "Ueberweisen",
  行情: "Markt",
  "24H成交": "24h Volumen",
  累计收益: "Gesamtertrag",
  充值时间: "Einzahlungsdatum",
  到期时间: "Verfallsdatum",
  数量: "Menge",
  操作: "Aktion",
  资产信息: "Vermögensinformationen",
  复制地址: "Adresse kopieren",
  链名称: "Blockchain Name",
  充值地址: "Einzahlungsadresse",
  收款地址: "Empfangsadresse",
  账单: "Rechnung",
  提现金额: "Auszahlungsbetrag",
  接收地址: "Empfangsadresse",
  交易密码: "Handelspasswort",
  提现全部: "Alles auszahlen",
  保存图片: "Bild speichern",
  输入您的交易密码: "Geben Sie Ihr Handelspasswort ein",
  确定: "Bestaetigen",
  地址: "Adresse",
  注册时间: "Registrierungsdatum",
  取消: "Abbrechen",
  是否划转: "Ueberweisen?",
  登录: "Anmelden",
  我的地址: "Meine Adressen",
  登录密码和交易密码: "Anmelde- und Handelspasswort",
  注册: "Registrieren",
  密码: "Passwort",
  设置密码: "Passwort festlegen",
  重复密码: "Passwort wiederholen",
  新密码: "Neues Passwort",
  确认新密码: "Neues Passwort bestaetigen",
  充值: "Einzahlen",
  充值货币: "Waehrung einzahlen",
  合约账户充值: "Futures Konto einzahlen",
  账户充值: "Konto einzahlen",
  其他: "Sonstiges",
  我的邀请码: "Mein Einladungscode",
  提现: "Auszahlen",
  客服: "Kundenservice",
  持有详情: "Details zum Besitz",
  请输入内容: "Inhalt eingeben",
  邀请好友来领取奖励: "Laden Sie Freunde ein und erhalten Sie Belohnungen",
  复制链接: "Link kopieren",
  重复设置新的密码: "Neues Passwort wiederholen",
  保存: "Speichern",
  我的: "Meins",
  "邮箱/手机号": "E-Mail/Handynummer",
  备注: "Bemerkung",
  地址管理: "Adressverwaltung",
  我的团队: "Mein Team",
  联系我们: "Kontakt",
  竭诚为您服务: "Wir stehen fuer Sie bereit",
  提取收益: "Ertrag abheben",
  带给我的收益: "Generierter Ertrag",
  添加: "Hinzufuegen",
  名称: "Name",
  添加地址: "Adresse hinzufuegen",
  修改地址: "Adresse aendern",
  可提现: "Auszahlbar",
  安全中心: "Sicherheitszentrum",
  收益划转: "Ertrag ueberweisen",
  通知中心: "Benachrichtigungen",
  "累计收益:": "Gesamtertrag:",
  注册用户: "Registrierte Benutzer",
  奖励规则: "Belohnungsregeln",
  帮助反馈: "Hilfe & Feedback",
  邀请好友: "Freunde einladen",
  恢复身份: "Identitaet wiederherstellen",
  选择语言: "Sprache waehlen",
  设置新的密码: "Neues Passwort festlegen",
  暂无活动: "Keine aktiven Aktionen",
  "月增长量(+)": "Monatliches Wachstum (+)",
  可提取: "Auszahlbar",
  反馈类型: "Feedback-Typ",
  赠送: "Geschenk",
  已经复制: "Kopiert",
  保存成功: "Erfolgreich gespeichert",
  划转成功: "Ueberweisung erfolgreich",
  过期: "Abgelaufen",
  提交成功: "Erfolgreich eingereicht",
  "服务器繁忙，稍后在试": "Server ausgelastet, bitte spaeter erneut versuchen",
  全部: "Alle",
  一级: "Stufe 1",
  二级: "Stufe 2",
  三级: "Stufe 3",
  级: "Stufe",
  删除成功: "Erfolgreich geloescht",
  选择地址: "Adresse auswaehlen",
  不再提醒: "Nicht mehr anzeigen",
  "最小充值金额：": "Mindesteinzahlungsbetrag:",
  选择币种: "Kryptowaehrung auswaehlen",
  输入投资金额: "Investitionsbetrag eingeben",
  输入账户密码: "Kontopasswort eingeben",
  投资: "Investieren",
  订单编号: "Bestellnummer",
  投资周期: "Investitionsdauer",
  投资资金: "Investierter Betrag",
  投资时间: "Investitionszeitpunkt",
  状态: "Status",
  投资中: "Aktiv",
  已到期: "Abgelaufen",
  暂无数据: "Keine Daten",
  转入: "Ueberweisung an",
  邮箱: "E-Mail",
  请输入邮箱: "E-Mail-Adresse eingeben",
  请输入格式正确的邮箱: "Bitte eine gueltige E-Mail-Adresse eingeben",
  请输入验证码: "Bestaetigungscode eingeben",
  获取验证码: "Bestaetigungscode anfordern",
  请输入邀请码: "Einladungscode eingeben",
  今天: "Heute",
  昨天: "Gestern",
  最近七天: "Letzte 7 Tage",
  邀请: "Einladen",
  购买数量: "Kaufmenge",
  产品详情: "Produktdetails",
  币种: "Kryptowaehrung",
  利息币种: "Ertragswaehrung",
  理财类型: "Art des Finanzprodukts",
  产品费率: "Produktgebuehren",
  进行中: "Aktiv",
  每天: "Taeglich",
  请输入搜索关键词: "Suchbegriff eingeben",
  通知: "Benachrichtigungen",
  查看更多: "Mehr ansehen",
  理财宝: "Finanzprodukte",
  周期: "Laufzeit",
  年利率: "Jaehrlicher Zinssatz (APY)",
  更多产品: "Weitere Produkte",
  灵活存取: "Flexibles Sparen",
  稳定收益: "Stabiler Ertrag",
  合约指南: "Futures Leitfaden",
  资金划转出: "Ausgehende Ueberweisung",
  矿池收益: "Mining-Belohnung",
  提现手续费: "Auszahlungsgebuehr",
  冻结资金: "Eingefrorenes Vermoegen",
  解冻资金: "Eingefrorenes Vermoegen freigeben",
  闪兑支出: "Ausgabe fuer Schnellwechsel",
  闪兑收入: "Einnahmen aus Schnellwechsel",
  闪兑手续费: "Gebuehr fuer Schnellwechsel",
  合约支出: "Ausgabe Futures",
  合约收入: "Einnahmen Futures",
  输入的金额不可大于可用金额:
    "Betrag darf nicht groesser sein als der verfuegbare Betrag",
  全部兑换成功: "Kompletter Wechsel erfolgreich",
  返回: "Zurueck",
  查看历史: "Verlauf ansehen",
  闪兑历史: "Verlauf des Schnellwechsels",
  支付: "Bezahlen",
  获取: "Erhalten",
  时间: "Zeit",
  手续费: "Transaktionsgebuehr",
  折扣: "Rabatt",
  价格: "Preis",
  逐仓: "Isolierter Margin",
  全仓: "Cross Margin",
  市价委托: "Marktorder",
  限价委托: "Limitorder",
  请输入本金: "Kapitalbetrag eingeben",
  请输入价格: "Preis eingeben",
  "可做空/做多": "Short/Long moeglich",
  设置止盈止损: "Take-Profit / Stop-Loss setzen",
  止盈价: "Take-Profit Preis",
  止损价: "Stop-Loss Preis",
  成本: "Kostenpreis",
  做多: "Long",
  做空: "Short",
  仓位信息: "Positionsinformationen",
  一键平仓: "Position schliessen (ein Klick)",
  永续: "Perpetual",
  浮动盈亏: "Unrealisierter Gewinn/Verlust",
  平仓: "Position schliessen",
  反向开仓: "Umgekehrte Position eroeffnen",
  一键撤销: "Alle abbrechen (ein Klick)",
  倍杠杆: "fach Hebel",
  执行价格: "Ausfuehrungspreis",
  委托数量: "Bestellmenge",
  保证金: "Margin",
  成交价: "Ausfuehrungspreis",
  创建时间: "Erstellungszeit",
  撤销: "Abbrechen",
  合约市场: "Futures Markt",
  交易方向: "Handelsrichtung",
  委托价格: "Bestellpreis",
  委托金额: "Bestellbetrag",
  资金费率: "Finanzierungszinssatz",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodische Gebuehr, die von Long- und Short-Positionen gezahlt wird, wird alle 8 Stunden verrechnet.",
  "资金费率为正，多方向空方支付资金费用。":
    "Bei positivem Finanzierungszinssatz zahlen Long-Positionen an Short-Positionen.",
  "资金费率为负，空方向多方支付资金费用。":
    "Bei negativem Finanzierungszinssatz zahlen Short-Positionen an Long-Positionen.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Sind Sie sicher, dass Sie eine umgekehrte Position eroeffnen moechten? Dies kauft die entgegengesetzte Richtung Ihrer aktuellen Position.",
  "仓位止盈/止损": "Take-Profit / Stop-Loss fuer Position",
  合约名称: "Futures Kontrakt",
  开仓价格: "Eroeffnungspreis",
  指数价格: "Indexpreis",
  止盈设置: "Take-Profit Einstellungen",
  请输入止盈价: "Take-Profit Preis eingeben",
  "当指数价格触达*时，将会触发委托平仓":
    "Wenn der Indexpreis * erreicht, wird eine Schliessungsorder ausgeloest.",
  预计盈亏: "Erwarteter Gewinn/Verlust",
  当前仓位: "Aktuelle Position",
  平仓金额: "Schliessungsbetrag",
  仓位模式: "Positionsmodus",
  全仓模式: "Cross Margin Modus",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Im Cross Margin Modus wird das gesamte verfuegbare Vermoegen auf Ihrem Futures-Konto als Margin verwendet. Eine Liquidation erfolgt, wenn der Verlust Ihr Gesamtguthaben uebersteigt, wodurch Sie Ihre gesamte Margin und Position verlieren.",
  逐仓模式: "Isolierter Margin Modus",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Ein bestimmter Margin-Betrag wird einer Position zugewiesen. Wenn der Margin-Verlust unter das Wartungsmargin-Niveau faellt, wird die Position liquidiert. Sie koennen die Margin fuer diese Position erhoehen oder verringern.",
  "是否撤销？": "Order abbrechen?",
  "是否一键撤销？": "Alle Orders abbrechen?",
  "是否一键平仓？": "Alle Positionen schliessen?",
  持仓保证金: "Margin fuer aktuelle Position",
  风险率: "Risikoprozentsatz",
  未实现盈亏: "Unrealisierter Gewinn/Verlust",
  可用保证金: "Verfuegbare Margin",
  净值: "Nettowert",
  账户余额: "Kontoguthaben",
  合约计算器: "Futures Rechner",
  交易记录: "Transaktionsverlauf",
  "*倍杠杆": "*fach Hebel",
  "平仓盈亏：": "Geschlossener Gewinn/Verlust:",
  时间筛选: "Zeitfilter",
  仓位类型: "Positionstyp",
  订单状态: "Bestellstatus",
  订单类型: "Bestelltyp",
  平仓价格: "Schliessungspreis",
  持仓数量: "Positionsmenge",
  "手续费(%)": "Transaktionsgebuehr (%)",
  平仓时间: "Schliessungszeit",
  平仓类型: "Schliessungstyp",
  手动平仓: "Manuell geschlossen",
  强制平仓: "Zwangsliquidierung",
  近1天: "Letzter Tag",
  近7天: "Letzte 7 Tage",
  近30天: "Letzte 30 Tage",
  近180天: "Letzte 180 Tage",
  持仓: "Offene Position",
  已取消: "Storniert",
  分时: "Intraday",
  "24H额(USDT)": "24h Volumen (USDT)",
  "24H低": "24h Tiefst",
  "24H量(BTC)": "24h Volumen (BTC)",
  "24H高": "24h Hochst",
  "10秒": "10 Sekunden",
  "30秒": "30 Sekunden",
  "1分": "1 Minute",
  "3分": "3 Minuten",
  "5分": "5 Minuten",
  "30分": "30 Minuten",
  "1小时": "1 Stunde",
  "4小时": "4 Stunden",
  "8小时": "8 Stunden",
  "1天": "1 Tag",
  "1周": "1 Woche",
  "1月": "1 Monat",
  单向持仓: "Einweg Position",
  杠杆: "Hebel",
  仓位: "Position",
  计算结果: "Ergebnis",
  盈亏: "Gewinn/Verlust",
  收益率: "Rendite",
  计算结果仅供参考: "Ergebnis ist indikativ",
  成交后仓位大小: "Positionsgroesse nach Ausfuehrung",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Ergebnis ist indikativ, tatsaechliche Ergebnisse koennen aufgrund von Gebuehren abweichen.",
  目标价格: "Zielpreis",
  开始计算: "Berechnen",
  强平价格: "Liquidationspreis",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Ueberpruefen Sie vor der Einzahlung sorgfaeltig den Blockchain-Namen. Falsche Einzahlungen koennen nicht rueckgaengig gemacht werden. Der Mindesteinzahlungsbetrag ist *. Einzahlungen unter diesem Betrag werden nicht verarbeitet. Senden Sie keine anderen Vermoegenswerte an diese Adresse. Verwenden Sie keine ICO- oder Crowdfunding-Adressen fuer Auszahlungen.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Die minimale Auszahlungsmenge ist *. Auszahlungsgebuehren werden vom Auszahlungsbetrag abgezogen. Ueberpruefen Sie die Empfaengeradresse sorgfaeltig. Senden Sie kein * an Adressen ausserhalb von *. Verwenden Sie keine ICO- oder Crowdfunding-Adressen.",
  退出登录: "Abmelden",
  加仓: "Position vergroessern",
  新增仓位: "Neue Position",
  输入加仓金额: "Betrag fuer Positionsvergroesserung eingeben",
  "当前可用:": "Aktuell verfuegbar:",
  资产账单: "Vermoegensrechnung",
  保存二维码: "QR-Code speichern",
  温馨提示: "Hinweis",
  "请注意：您当前使用的网络":
    "Bitte beachten Sie: Sie verwenden derzeit das Netzwerk",
  输入提现地址: "Auszahlungsadresse eingeben",
  "可用金额：": "Verfuegbarer Betrag:",
  输入资产密码: "Vermoegenspasswort eingeben",
  可用手续费: "Verfuegbare Transaktionsgebuehr",
  "折扣%": "Rabatt %",
  实扣手续费: "Tatsaechlich berechnete Gebuehr",
  实际到账: "Tatsaechlich erhaltener Betrag",
  未设置资产密码: "Kein Vermoegenspasswort festgelegt",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Legen Sie aus Sicherheitsgruenden ein Vermoegenspasswort fest, bevor Sie Auszahlungen vornehmen.",
  热榜: "Beliebt",
  涨幅榜: "Steiger",
  跌幅榜: "Faller",
  成交额榜: "Volumen Rangliste",
  关于我们: "Ueber uns",
  登录密码: "Anmelde Passwort",
  设置: "Einstellungen",
  资产密码: "Vermoegenspasswort",
  修改登录密码: "Anmelde Passwort aendern",
  原密码: "Altes Passwort",
  请输入新密码: "Neues Passwort eingeben",
  请输入原密码: "Altes Passwort eingeben",
  确认密码: "Passwort bestaetigen",
  确定修改: "Aenderung bestaetigen",
  修改资产密码: "Vermoegenspasswort aendern",
  验证码: "Bestaetigungscode",
  资产密码使用提示: "Vermoegenspasswort Tipps",
  "资产密码用于转移、提取资产和交易。":
    "Das Vermoegenspasswort wird verwendet, um Vermoegen zu transferieren, abzuheben und zu handeln.",
  "创建与登录密码不同的资产密码。":
    "Waehlen Sie ein anderes Passwort als Ihr Anmelde Passwort.",
  "定期更改您的资产密码。": "Aendern Sie Ihr Vermoegenspasswort regelmaessig.",
  提币历史: "Auszahlungsverlauf",
  "金额/余额": "Betrag/Guthaben",
  "手续费/折扣": "Gebuehr/Rabatt",
  自选: "Favoriten",
  现货: "Spot",
  市价: "Marktpreis",
  止损设置: "Stop-Loss Einstellungen",
  合约K线图: "Futures Chart",
  "24H量": "24h Volumen",
  "24H额": "24h Volumen (USDT)",
  合作指南: "Partner Leitfaden",
  盈亏计算: "Gewinn/Verlust Berechnung",
  当前可用: "Aktuell verfuegbar",
  请输入加仓金额: "Betrag fuer Positionsvergroesserung eingeben",
  请重新输入加仓金额:
    "Bitte geben Sie den Betrag fuer die Positionsvergroesserung erneut ein",
  平仓数量: "Zu schliessende Menge",
  欢迎登录: "Willkommen zurueck",
  "忘记密码?": "Passwort vergessen?",
  "还没有账号？": "Noch kein Konto?",
  立即注册: "Jetzt registrieren",
  繁體中文: "Traditionelles Chinesisch",
  找回密码: "Passwort wiederherstellen",
  下一步: "Weiter",
  注册账户: "Konto registrieren",
  "请输入邀请码(选填)": "Einladungscode eingeben (optional)",
  谢邀豪礼: "Einladungsbonus",
  "24小时邀请好友排名": "24h Einladungsrangliste",
  "*人": "* Personen",
  "差*人": "Noch * Personen benoetigt",
  "已超过10万人，每月轻松赚钱":
    "Mehr als 100'000 Benutzer, verdienen Sie einfach jeden Monat",
  最高: "Maximum",
  邀请链接: "Einladungslink",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Teilen Sie an den Transaktionsgebuehren, die Ihre Freunde (Spot, Futures, Margin, Schnellwechsel) generieren.",
  平台和您一起分享手续费:
    "Teilen Sie die Transaktionsgebuehren mit der Plattform",
  "*级": "* Stufe",
  规则: "Regeln",
  我的好友: "Meine Freunde",
  好友详情: "Freunddetails",
  获得好友佣金方案: "Freundesprovisionsplan",
  我的等级: "Meine Stufe",
  我的邀请数据: "Meine Einladungsstatistiken",
  当前等级: "Aktuelle Stufe",
  平台奖励您: "Plattformbelohnung fuer Sie",
  最高可获取平台奖励: "Maximale Plattformbelohnung",
  邀请规则: "Einladungsregeln",
  "邀请*级有效好友": "Laden Sie * Stufe aktive Freunde ein",
  好友等级: "Freundesstufe",
  人: "Personen",
  奖金派送: "Bonusauszahlung",
  平台奖励: "Plattformbelohnung",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Die Plattform hat das Recht auf Auslegung. Bei betruegerischen Aktivitaeten werden Belohnungen abgezogen und Ihr Konto wird eingefroren. Verlorene Vermoegenswerte koennen nicht wiederhergestellt werden.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Ihr Konto muss aktiv sein, definiert als eine Einzahlung von mindestens * USDT Wert in einer beliebigen Kryptowaehrung.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Ihr eingeladener Freund muss ein aktiver Downline sein, definiert als eine Einzahlung von mindestens * USDT Wert.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Einlader und Eingeladener duerfen nicht die gleiche IP-Adresse teilen.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-Stufe wird durch die Anzahl der eingeladenen Freunde der Stufe * bestimmt.",
  佣金成分: "Provisionsbestandteile",
  收益统计: "Ertragsstatistiken",
  昨日收益: "Ertrag von gestern",
  月收益: "Monatsertrag",
  获取收益: "Ertrag erhalten",
  "总收益：": "Gesamtertrag:",
  "*级好友": "* Stufe Freunde",
  理财购买: "Finanzprodukt kaufen",
  期限: "Laufzeit",
  可用金额: "Verfuegbarer Betrag",
  预估收益: "Geschaetzter Ertrag",
  申购上限: "Maximaler Kauf",
  项目剩余: "Restprojekt",
  "买入后预计*(SGT)开始计算收益。":
    "Ertrag beginnt voraussichtlich um *(SGT) nach dem Kauf.",
  计息日: "Verzinsungsbeginn",
  申购日: "Kaufdatum",
  到账日: "Gutschriftsdatum",
  到期自动续投: "Automatische Wiederanlage bei Faelligkeit",
  申购: "Kaufen",
  搜索理财项目: "Finanzprodukt suchen",
  超高年化随心选: "Waehlen Sie aus Produkten mit hoher Rendite",
  "自由选择理财币种，稳定超额收益":
    "Waehlen Sie frei Ihre Kryptowaehrung fuer stabile, ueberdurchschnittliche Renditen",
  理财总资产: "Investiertes Gesamtvermoegen",
  申购数量: "Zu kaufende Menge",
  立即购买: "Sofort kaufen",
  年化收益率: "Jaehrliche Rendite (APY)",
  理财订单: "Finanzprodukt Bestellungen",
  持有: "Im Besitz",
  申购份额: "Gekaufter Anteil",
  到账日期: "Gutschriftsdatum",
  申购成功: "Kauf erfolgreich",
  到期: "Abgelaufen",
  是否选择做多: "Long gehen?",
  "可用余额为0 不能操作": "Guthaben ist 0, Aktion nicht moeglich",
  福利中心: "Bonuszentrum",
  奖励记录: "Belohnungsverlauf",
  我获取到的奖励: "Meine verdienten Belohnungen",
  总价值: "Gesamtwert",
  新手任务: "Aufgaben fuer Neueinsteiger",
  身份认证: "Identitaetsverifikation (KYC)",
  身份验证: "Identitaetsverifikation",
  去验证: "Jetzt verifizieren",
  审核中: "In Wartestellung",
  已验证: "Verifiziert",
  认证失败: "Verifikation fehlgeschlagen",
  基础认证: "Basis Verifikation",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Bitte beachten Sie: Verifizierte Informationen koennen nicht mehr geaendert werden. Geben Sie korrekte Daten ein.",
  "国家/地区": "Land/Region",
  请选择: "Auswaehlen",
  证件类型: "Dokumententyp",
  证件编码: "Dokumentennummer",
  身份证: "Personalausweis",
  护照: "Reisepass",
  驾驶证: "Fuehrerschein",
  请输入编码: "Nummer eingeben",
  名字: "Vorname",
  请输入: "Eingeben",
  中间名: "Zweitname",
  选填: "Optional",
  姓氏: "Nachname",
  中国: "China",
  身份上传: "Identitaetsdokument hochladen",
  上传身份证: "Personalausweis hochladen",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Bitte im JPG/JPEG/PNG-Format hochladen. Stellen Sie sicher, dass die Bilder klar, vollstaendig und gleichmaessig ausgeleuchtet sind. Maximal *MB.",
  确定提交: "Absenden",
  去认证: "Verifizieren",
  挑战任务: "Herausforderungsaufgaben",
  注册认证任务: "Registrierungs- und Verifikationsaufgabe",
  完成注册认证即可领取:
    "Schliessen Sie Registrierung und Verifikation ab, um zu erhalten",
  领取奖励: "Belohnung erhalten",
  新人豪礼: "Willkommensbonus",
  "参与人数：": "Anzahl der Teilnehmer:",
  条件: "Bedingung",
  入金量: "Einzahlungsbetrag",
  完成: "Abgeschlossen",
  任务奖励: "Aufgabenbelohnung",
  距任务更新: "Bis zur Aufgabenaktualisierung",
  "条件：": "Bedingung:",
  活动规则: "Aktionsregeln",
  奖励明细: "Belohnungsdetails",
  已获得: "Erhalten",
  交易奖励: "Handelsbelohnung",
  Win奖励: "WIN Belohnung",
  已领取: "Erhalten",
  亏损金额超过: "Verlustbetrag ueberschreitet",
  单笔开仓金额超过: "Einzelorderbetrag ueberschreitet",
  交易量: "Handelsvolumen",
  待完成: "Ausstehend",
  入金: "Einzahlen",
  盈利金额超过: "Gewinnbetrag ueberschreitet",
  开仓金额: "Orderbetrag",
  开仓金: "Orderbetrag",
  盈利: "Gewinn",
  亏损: "Verlust",
  领取: "Erhalten",
  未领取: "Nicht erhalten",
  待领取: "Zu erhalten",
  再交易: "Weiter handeln",
  即可获得: "um zu erhalten",
  领取成功: "Erfolgreich erhalten",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alle Aktivitaeten werden zum Enddatum abgerechnet. Belohnungen verfallen danach.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Verdienter Ertrag wird Ihrem Bounty-Konto gutgeschrieben, den Sie jederzeit umtauschen oder auszahlen koennen.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Die Belohnungskryptowaehrung haengt von der Aufgabe ab.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Die Plattform hat das Recht auf Auslegung. Bei Betrug mit Aufgaben werden Belohnungen einbehalten und Ihr Konto kann eingefroren werden.",
  成长学院: "Akademie",
  "区块链 & 加密货币": "Blockchain & Kryptowaehrung",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Ihr umfassender Leitfaden fuer Kryptowaehrung. Wir begleiten Sie auf Ihrer Krypto-Reise.",
  "全仓合约定单的全部保证金。":
    "Gesamte Margin fuer Cross Margin Futures Orders.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Guthaben + (unrealisierter Gewinn/Verlust - Gebuehren - Finanzierungszins) = Nettowert / Verwendete Margin * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Unrealisierter Gewinn/Verlust hat direkten Einfluss auf die 'verfuegbare Margin'. Steigt der unrealisierte Gewinn/Verlust, steigt die verfuegbare Margin und umgekehrt.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Guthaben - (Verwendete Margin) + (unrealisierter Gewinn/Verlust - Gebuehren - Finanzierungszins)",
  "注:可继续用于开仓的保证金。":
    "Hinweis: Margin, die verfuegbar ist, um neue Positionen zu eroeffnen.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Guthaben + (unrealisierter Gewinn/Verlust - Gebuehren - Finanzierungszins)",
  "注:当前的资金结余。": "Hinweis: Aktuelles Guthaben.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Bezieht sich auf das Gesamtguthaben des Futures-Kontos, einschliesslich eingefrorener Betraege.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Hinweis: Je hoeher der Risikoprozentsatz, desto geringer das Risiko, und umgekehrt.",
  该功能尚未开发: "Diese Funktion befindet sich noch in Entwicklung",
  重置密码: "Passwort zuruecksetzen",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Bitte geben Sie 8-20 Zeichen ein, einschliesslich Buchstaben, Ziffern und Sonderzeichen",
  修改成功: "Aenderung erfolgreich",
  输入验证码: "Bestaetigungscode eingeben",
  输入密码: "Passwort eingeben",
  详情说明: "Details",
  已售罄: "Ausverkauft",
  剩余期限: "Restlaufzeit",
  限期: "Laufzeit",
  闪兑货币选择: "Waehrung fuer Schnellwechsel auswaehlen",
  地区选择: "Region auswaehlen",
  "搜索国家/地区": "Land/Region suchen",
  "身份信息已提交，将在*小时内审核完成":
    "Identitaetsinformationen wurden uebermittelt. Die Verarbeitung dauert bis zu * Stunden.",
  "选择国家/地区": "Land/Region auswaehlen",
  "止盈价格需高于*": "Take-Profit Preis muss hoeher sein als *",
  "止损价格需低于*": "Stop-Loss Preis muss niedriger sein als *",
  "止盈价格需低于*": "Take-Profit Preis muss niedriger sein als *",
  "止损价格需高于*": "Stop-Loss Preis muss hoeher sein als *",
  教程详情: "Tutorialdetails",
  请输入止损价: "Stop-Loss Preis eingeben",
  活期: "Flexibel",
  赎回后立即到账: "Sofortige Gutschrift nach Ruecknahme",
  赎回: "Zuruecknehmen",
  赎回理财: "Finanzprodukt zuruecknehmen",
  是否赎回当前的理财订单: "Aktuelle Finanzbestellung zuruecknehmen?",
  维护: "Wartung",
  "系统正在维护中……": "System wird gewartet...",
  合约: "Futures",
  闪电兑换: "Schnellwechsel",
  流水挖矿: "Volumen Mining",
  邀请豪礼: "Einladungsbonus",
  计算器: "Rechner",
  最新价: "Letzter Preis",
  涨跌幅: "Aenderung (24h)",
  关注币种添加自选: "Kryptowaehrung zu Favoriten hinzufuegen",
  一键添加自选: "Zu Favoriten hinzufuegen (ein Klick)",
  全标已读: "Alle als gelesen markieren",
  无消息: "Keine Nachrichten",
  "暂时还没有收到任何消息通知哦!":
    "Sie haben noch keine Benachrichtigungen erhalten!",
  没有更多数据: "Keine weiteren Daten",
  闪兑: "Schnellwechsel",
  从: "Von",
  "可用余额：": "Verfuegbares Guthaben:",
  至: "Nach",
  预览兑换结果: "Wechselergebnis ansehen",
  闪兑规则: "Regeln fuer Schnellwechsel",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Schnellwechsel unterliegen Marktschwankungen. Der tatsaechlich erhaltene Betrag ist massgeblich.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Wechselkurse werden von Drittanbietern festgelegt. Aufgrund von Kosten und Schwankungen kann der Kurs vom Marktkurs abweichen. Bitte sorgfaeltig pruefen.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Die Plattform berechnet etwa *% Gebuehr pro Wechsel, um die Kosten an Boersen zu decken.",
  确认汇兑: "Wechsel bestaetigen",
  您预估得到: "Geschaetzter Erhalt",
  汇兑: "Wechsel",
  汇兑比例: "Wechselkurs",
  刷新: "Aktualisieren",
  兑换: "Tauschen",
  没有更多了: "Keine weiteren Daten",
  搜索币种: "Kryptowaehrung suchen",
  可用: "Verfuegbar",
  我知道了: "Ich habe verstanden",
  最新价格: "Letzter Preis",
  确认: "Bestaetigen",
  最大: "Maximum",
  "风险率(%)": "Risikoprozentsatz (%)",
  当前委托: "Aktuelle Orders",
  合作交易历史记录: "Partner Transaktionsverlauf",
  重置: "Zuruecksetzen",
  余额: "Guthaben",
  现货账户: "Spotkonto",
  合约账户: "Futures Konto",
  WIN账户: "WIN Konto",
  赏金账户: "Bounty Konto",
  总资产折合: "Gesamtvermoegen (in USDT)",
  今日收益: "Heutiger Ertrag",
  充币: "Einzahlen",
  提币: "Auszahlen",
  账户权益: "Kontowert",
  "数量/类别": "Menge/Kategorie",
  全部币种: "Alle Kryptowaehrungen",
  全部类型: "Alle Typen",
  账单信息: "Rechnungsinformationen",
  理财赎回: "Finanzprodukt Ruecknahme",
  购买理财: "Finanzprodukt kaufen",
  收入: "Einnahmen",
  支出: "Ausgaben",
  到: "an",
  资产划转: "Vermoegen transferieren",
  "最少*": "Mindestens *",
  "可用资产：": "Verfuegbare Vermoegenswerte:",
  确认划转: "Transfer bestaetigen",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Sie muessen Vermoegen auf das entsprechende Konto transferieren, um handeln zu koennen. Transfers zwischen Konten sind gebuehrenfrei.",
  币种账户选择: "Kryptowaehrungskonto auswaehlen",
  选择账户: "Konto auswaehlen",
  划转详情: "Transferdetails",
  划转明细: "Transferdetails",
  收入账单: "Einnahmenrechnung",
  支出账单: "Ausgabenrechnung",
  金额: "Betrag",
  总收益: "Gesamtertrag",
  佣金: "Provision",
  用户名: "Benutzername",
  "已领取：": "Erhalten:",
  "未领取：": "Nicht erhalten:",
  "请选择国家/地区": "Bitte waehlen Sie Land/Region",
  请上传身份信息: "Bitte laden Sie Identitaetsinformationen hoch",
  请选择证件类型: "Bitte waehlen Sie Dokumententyp",
  请填写证件编码: "Bitte geben Sie Dokumentennummer ein",
  请填写名字: "Bitte geben Sie Vorname ein",
  请填写姓氏: "Bitte geben Sie Nachname ein",
  投资金额: "Investitionsbetrag",
  天: "Tage",
  请输入手机号: "Bitte geben Sie Handynummer ein",
  搜索: "Suchen",
  搜索历史: "Suchverlauf",
  热门推荐: "Beliebte Empfehlungen",
  "《Xspace Earn协议》": "Xspace Earn Protokoll",
  我已了解并同意: "Ich habe verstanden und stimme zu",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace offizielle chinesische Community",
  Xspace官方英文交流群: "Xspace offizielle englische Community",
  预计维护至: "Voraussichtliche Wartung bis",
  更多功能: "Weitere Funktionen",
  下载APP: "App herunterladen",
  理财: "Finanzprodukt",
  推荐: "Empfohlen",
  Telegram官方中文频道: "Offizieller Telegram-Kanal (Chinesisch)",
  Telegram官方英文频道: "Offizieller Telegram-Kanal (Englisch)",
  官方邮箱: "Offizielle E-Mail-Adresse",
  客服邮箱: "Kundenservice E-Mail-Adresse",
  上述信息最终解释权归官方所有:
    "Die endgueltige Auslegung der vorstehenden Informationen obliegt der Plattform.",
  IOS版下载: "Fuer iOS herunterladen",
  Android版下载: "Fuer Android herunterladen",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaktionsgebuehr = Kaufgebuehr + Finanzierungszinssatz + Verkaufgebuehr",
  资金划转: "Vermoegen transferieren",
  止盈: "Take-Profit",
  止损: "Stop-Loss",
  自动平仓: "Automatisches Schliessen",
  委托挂单: "Offene Order",
  买: "Kaufen",
  卖: "Verkaufen",
  "买入/做多": "Kaufen/Long",
  "卖出/做空": "Verkaufen/Short",
  详情: "Details",
  浮动涨跌: "Unrealisierter Gewinn/Verlust",
  最小: "Minimum",
  充币数量: "Einzahlungsmenge",
  请输入充币数量: "Bitte geben Sie die Einzahlungsmenge ein",
  支付截图: "Zahlungsnachweis",
  提交: "Absenden",
  上传驾驶证: "Fuehrerschein hochladen",
  上传护照: "Reisepass hochladen",
  加载中: "Laedt...",
  上传成功: "Upload erfolgreich",
  充值历史: "Einzahlungsverlauf",
  合约卖出手续费: "Futures Verkaufgebuehr",
  合约买入手续费: "Futures Kaufgebuehr",
  系统加款: "Systemgutschrift",
  系统减款: "Systembelastung",
  合约资金费率: "Futures Finanzierungszinssatz",
  佣金分成: "Provisionsaufteilung",
  U本位合约: "USDT-marginierte Futures",
  资产管理: "Vermoegensverwaltung",
  APP下载: "App herunterladen",
  全球领先的数字理财平台: "Weltweit fuehrende digitale Finanzplattform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handeln Sie sofort Bitcoin, Ethereum und hunderte andere digitale Vermoegenswerte",
  "24H涨跌幅": "24h Aenderung",
  查看更多行情: "Weitere Maerkte ansehen",
  近24小时成交量: "24h Volumen",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Bietet hunderte von Spot- und Futures-Paaren. Mehr als 20 Millionen Benutzer in 200+ Laendern. Eine weltweit fuehrende digitale Vermoegensplattform.",
  用户国家分布: "Benutzer nach Land",
  用户数: "Anzahl Benutzer",
  交易对: "Handelspaare",
  服务支持: "Unterstuetzung",
  "随时随地，多平台终端交易":
    "Handeln Sie ueberall mit Multi-Plattform-Unterstuetzung",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Perfekt kompatibel mit mehreren Geraeten fuer alle Handelsbeduerfnisse.",
  随时查看实时行情: "Sehen Sie Echtzeitkurse immer und ueberall",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Kaufen und verkaufen Sie einfach BTC, ETH, DOGE und andere digitale Vermoegenswerte",
  获取您关注的加密货币价格变化预警:
    "Erhalten Sie Preiswarnungen fuer Kryptowaehrungen, die Sie verfolgen",
  "查看比特币现货、期货、期权价格":
    "Sehen Sie Bitcoin Spot-, Futures- und Optionspreise",
  比较各交易所加密货币价格:
    "Vergleichen Sie Kryptowaehrungspreise ueber Boersen hinweg",
  开启您的数字货币之旅: "Starten Sie Ihre Reise mit digitalen Vermoegenswerten",
  快捷购买数字货币: "Kaufen Sie schnell Kryptowaehrungen",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handeln Sie sicher und schnell mit mehreren Zahlungsmethoden",
  最优的交易费率: "Die besten Transaktionsgebuehren",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Guenstige Tarife, wettbewerbsfaehige VIP-Vorteile und Service von hoechster Qualitaet.",
  可信赖的安全保障: "Vertrauenswuerdige Sicherheit",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Fortschrittliche Sicherheitsmassnahmen und der SAFU-Fonds schuetzen Ihre Vermoegenswerte vor Risiken.",
  交易: "Handeln",
  币币市场: "Spotmarkt",
  "24H成交量": "24h Volumen",
  交易所: "Boerse",
  "24H最高": "24h Hochst",
  "24H最低": "24h Tiefst",
  永续合约: "Perpetual Futures",
  日涨跌: "Taegliche Aenderung",
  交易深度: "Orderbuchtiefe",
  "资产(合约)": "Vermoegen (Futures)",
  历史仓位: "Positionsverlauf",
  兑换记录: "Wechselverlauf",
  类型: "Typ",
  充值记录: "Einzahlungsverlauf",
  划转记录: "Transferverlauf",
  类别: "Kategorie",
  历史账单: "Rechnungsverlauf",
  在线充值: "Online Einzahlung",
  安全设置: "Sicherheitseinstellungen",
  用于账户登录使用: "Wird fuer die Kontoanmeldung verwendet",
  用户提现时安全验证使用:
    "Wird fuer die Sicherheitsverifikation bei Auszahlungen verwendet",
  验证: "Verifizieren",
  万: "Million",
  随时随地开启交易: "Beginnen Sie jederzeit und ueberall mit dem Handel",
  "*货币交易所的所有功能尽在你的手中。":
    "Alle Funktionen der * Kryptoboerse in Ihrer Hand.",
  "下载*货币交易所APP。": "Laden Sie die * Kryptoboerse App herunter.",
  下载自: "Herunterladen von",
  内测版: "Beta-Version",
  下载: "Herunterladen",
  扫码下载: "Scannen zum Herunterladen",
  设置您的资产密码: "Legen Sie Ihr Vermoegenspasswort fest",
  法币: "Fiat",
  我要买: "Ich moechte kaufen",
  我要卖: "Ich moechte verkaufen",
  请输入金额: "Betrag eingeben",
  汇率: "Wechselkurs",
  获得: "Erhalten",
  支付通道: "Zahlungskanal",
  收款通道: "Empfangskanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Stellen Sie sicher, dass der Empfangskanal auf Ihren eigenen Namen lautet, wenn Sie verkaufen.",
  当前法币暂不支持交易对可尝试前往提现:
    "Dieses Fiat-Paar wird derzeit nicht unterstuetzt. Versuchen Sie eine Auszahlung.",
  前往提现: "Zur Auszahlung",
  该法币暂无通道: "Kein verfuegbarer Kanal fuer diese Fiat-Waehrung",
  "正在出售中，请耐心等待": "Verkauf laeuft, bitte haben Sie Geduld",
  请选择支付通道: "Bitte waehlen Sie Zahlungskanal",
  请选择方式: "Bitte waehlen Sie Methode",
  法币历史: "Fiat Verlauf",
  买币: "Krypto kaufen",
  卖币: "Krypto verkaufen",
  失败: "Fehlgeschlagen",
  已完成: "Abgeschlossen",
  未付款: "Unbezahlt",
  待审核: "In Wartestellung",
  打款中: "Auszahlung laeuft",
  订单详情: "Bestelldetails",
  联系客服: "Kundenservice kontaktieren",
  到账金额: "Erhaltener Betrag",
  通道: "Kanal",
  收款人: "Empfaenger",
  收款账户: "Empfaengerkonto",
  "订单出售失败，请查下方失败原因":
    "Verkaufsorder fehlgeschlagen. Grund siehe unten.",
  失败原因: "Grund fuer Fehlschlag",
  您还未进行付款: "Sie haben noch nicht bezahlt",
  您已成功购买: "Kauf erfolgreich",
  已取消订单: "Bestellung storniert",
  "订单正在审核中，请耐心等待":
    "Bestellung in Bearbeitung. Bitte haben Sie Geduld.",
  您已成功出售: "Verkauf erfolgreich",
  "订单正在打款中，请耐心等待": "Auszahlung laeuft. Bitte haben Sie Geduld.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Fuer die Zahlung muessen Sie eine andere Plattform besuchen. Achten Sie auf Ihre Informationssicherheit.",
  当前法币暂不支持交易对可尝试前往充值:
    "Dieses Fiat-Paar wird derzeit nicht unterstuetzt. Versuchen Sie eine Einzahlung.",
  前往充值: "Zur Einzahlung",
  购买: "Kaufen",
  订单号: "Bestellnummer",
  单价: "Stueckpreis",
  到账数量: "Erhaltene Menge",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Es gibt eine unbezahlte Bestellung. Neue Zahlungsbestellung starten?",
  继续支付: "Weiter bezahlen",
  重新下单: "Neue Bestellung aufgeben",
  是否确定出售: "Sind Sie sicher, dass Sie verkaufen moechten?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Nach der Bestaetigung weist die Plattform einen Kaeufer zu. Bitte warten Sie auf das Matching.",
  出售: "Verkaufen",
  收款方式: "Empfangsmethode",
  订单已生成: "Bestellung generiert",
  取消订单: "Bestellung stornieren",
  请在: "Bitte innerhalb",
  内完成付款: "bezahlen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Verlassen Sie die Plattform, loggen Sie sich in Ihre gewaehlte Zahlungsmethode ein und ueberweisen Sie den Betrag auf das untenstehende Konto des Verkaeufers. Geben Sie unbedingt die Referenz an:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Ohne Referenz kann der Verkaeufer die Zahlung nicht bestaetigen, was zum Verlust von Vermoegen fuehren kann.",
  "未在规定的时间内付款，订单都将被取消。":
    "Wenn Sie nicht innerhalb der vorgegebenen Zeit bezahlen, wird die Bestellung storniert.",
  姓名: "Name",
  收款姓名: "Name Empfaenger",
  开户支行: "Bankfiliale",
  银行卡号: "Bankkartennummer",
  "付款后，返回本平台":
    "Kehren Sie nach der Zahlung zu dieser Plattform zurueck",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Bitte klicken Sie auf den Button 'Ich habe bezahlt, Verkaeufer benachrichtigen'",
  未点击卖家不会放款:
    "Der Verkaeufer gibt die Krypto erst frei, nachdem Sie auf den Button geklickt haben",
  交易条款: "Transaktionsbedingungen",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Die Mittel fuer den Kauf muessen legal und sicher sein",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Betrug, Pyramidenspiele, Gluecksspiel oder andere illegale Mittel sind nicht erlaubt",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Wenn nach der Transaktion das Geld eingefroren wird oder verdaechtig ist, geben wir die USDT nicht frei und erstatten eine Rueckzahlung",
  "已付款，通知卖家": "Bezahlt, Verkaeufer benachrichtigen",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Wenn Sie heute insgesamt * Bestellungen stornieren, wird Ihr Kaufrecht fuer heute entzogen. Diese Bestellung stornieren?",
  添加收款方式: "Empfangsmethode hinzufuegen",
  是否删除此收款方式: "Diese Empfangsmethode loeschen?",
  删除: "Loeschen",
  请选择法币: "Bitte waehlen Sie Fiat-Waehrung",
  机构名称: "Name des Instituts",
  请选择机构: "Bitte waehlen Sie Institut",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Ihre gewaehlte Empfangsmethode wird Kaeufern angezeigt, wenn Sie Krypto verkaufen. Bitte stellen Sie sicher, dass die Daten korrekt sind.",
  请选择银行: "Bitte waehlen Sie Bank",
  请输入姓名: "Bitte geben Sie Name ein",
  账号: "Kontonummer",
  请输入账号: "Bitte geben Sie Kontonummer ein",
  收款码: "Empfangscode",
  "银行账号/卡号": "Bankkonto/Kartennummer",
  "请输入银行账号/卡号": "Bitte geben Sie Bankkonto/Kartennummer ein",
  "开户支行（选填）": "Bankfiliale (optional)",
  请输入开户支行: "Bitte geben Sie Bankfiliale ein",
  "加入*官方频道": "Werden Sie Mitglied des offiziellen * Kanals",
  关于: "Ueber",
  条款: "Bedingungen",
  成功: "Erfolgreich",
  等待: "Warten",
  作废: "Ungueltig",
  确认付款: "Zahlung bestaetigen",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Zahlung abgeschlossen? Nach der Bestaetigung prueft der Verkaeufer den Zahlungseingang innerhalb von * Minuten.",
  最大金额: "Maximalbetrag",
  最小金额: "Mindestbetrag",
  付款: "Bezahlen",
  法币充值: "Fiat einzahlen",
  法币提现: "Fiat auszahlen",
  待支付: "Zu bezahlen",
  已支付: "Bezahlt",
  商户名: "Verkaeufername",
  当前没有添加支付方式: "Keine Zahlungsmethode hinzugefuegt",
  添加后再出售: "Fuegen Sie eine hinzu, bevor Sie verkaufen",
  新人大礼包: "Willkommenspaket",
  注册即可领取: "Nach Registrierung erhalten",
  立即领取: "Jetzt erhalten",
  不再提示: "Nicht mehr anzeigen",
  "该奖励需在APP中领取，请下载APP":
    "Diese Belohnung kann nur in der App erhalten werden. Bitte laden Sie die App herunter.",
  去交易: "Handeln gehen",
  期权交易: "Optionshandel",
  交易额: "Handelsbetrag",
  可用额度: "Verfuegbares Limit",
  交易周期: "Handelszeitraum",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Aktuelle Position",
  胜率: "Gewinnquote",
  "盈利/亏损数": "Anzahl Gewinn/Verlust Transaktionen",
  累计实现盈亏: "Realisierter Gesamtgewinn/Verlust",
  秒: "Sekunden",
  分: "Minuten",
  小时: "Stunden",
  周: "Woche",
  下单时间: "Bestellzeit",
  剩余时间: "Restzeit",
  买入价: "Kaufpreis",
  结算价: "Abrechnungspreis",
  实现盈利: "Realisierter Gewinn",
  结算时间: "Abrechnungszeit",
  期权: "Option",
  新手教程: "Leitfaden fuer Anfaenger",
  我的订单: "Meine Bestellungen",
  赔率: "Quote",
  全部订单: "Alle Bestellungen",
  持有订单: "Offene Bestellungen",
  历史订单: "Bestellverlauf",
  输入交易额度: "Handelsbetrag eingeben",
  选择交易周期: "Handelszeitraum auswaehlen",
  去注册: "Registrieren",
  冻结: "Einfrieren",
  期权支出: "Optionsausgabe",
  期权收入: "Optionseinnahme",
  用户提现: "Benutzerauszahlung",
  "是否购买？": "Diese Option kaufen?",
  购买成功: "Kauf erfolgreich",
  请签名: "Bitte unterschreiben",
  提交签名: "Unterschrift einreichen",
  清空签名: "Unterschrift loeschen",
  签名审核中: "Unterschrift in Pruefung",
  已提交: "Eingereicht",
  扫一扫下载APP: "Scannen Sie, um die App herunterzuladen",
  新手领取大礼包: "Neukunden Willkommenspaket",
  注册实名即送彩金:
    "Registrieren und verifizieren Sie sich, um einen Bonus zu erhalten",
  交易总额: "Gesamthandelsvolumen",
  资产不足: "Unzureichende Vermoegenswerte",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Unzureichende Vermoegenswerte auf dem WIN-Konto. Sie koennen Vermoegen von Ihrem Hauptkonto transferieren.",
  Win: "WIN",
  比赛: "Wettbewerb",
  未开始: "Nicht begonnen",
  赛程: "Zeitplan",
  赛果: "Ergebnis",
  已结束: "Beendet",
  让球: "Handicap",
  进球数: "Tore",
  大: "Ueber",
  小: "Unter",
  胜负平: "1X2 (Sieg/Unentschieden/Niederlage)",
  和局: "Unentschieden",
  投注: "Einsatz",
  下注金额: "Einsatzbetrag",
  下注: "Einsatz plaetzen",
  阵容: "Aufstellung",
  分析: "Analyse",
  输入下注金额: "Einsatzbetrag eingeben",
  下注成功: "Einsatz erfolgreich",
  投注记录: "Einsatzverlauf",
  未结算: "Nicht abgerechnet",
  已结算: "Abgerechnet",
  流水: "Umsatz",
  输赢: "Gewinn/Verlust",
  赛时: "Wettkampfzeit",
  下注时间: "Einsatzzeit",
  足彩竞猜: "Fussballwette",
  查看详情: "Details ansehen",
  输: "Verlust",
  赢: "Gewinn",
  主: "Heim",
  客: "Auswaerts",
  主胜: "Heimsieg",
  客胜: "Auswaertssieg",
  平: "Unentschieden",
  已延期: "Verschoben",
  账号异常: "Kontoanomalie",
  全场独赢: "Vollzeit 1X2",
  全场让球: "Vollzeit Handicap",
  全场大小: "Vollzeit Ueber/Unter",
  总进球: "Gesamttore",
  拍摄照片要求: "Fotoanforderungen",
  标准拍摄: "Standardfoto",
  边框缺失: "Rand fehlt",
  照片模糊: "Foto unscharf",
  闪光强烈: "Blitz zu stark",
  上传手持证件照: "Foto mit Dokument in der Hand hochladen",
  上传证件照: "Dokumentfoto hochladen",
  换一张: "Neues Foto",
  出生日期: "Geburtsdatum",
  请选择出生日期: "Bitte waehlen Sie Geburtsdatum",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Geben Sie den untenstehenden Verifikationscode ein, um einen E-Mail-Code fuer die Registrierung zu erhalten.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Sie haben noch * Verifikationsversuche uebrig. Danach koennen Sie sich nicht mehr verifizieren.",
  上半场: "1. Halbzeit",
  下半场: "2. Halbzeit",
  独赢: "1X2",
  上半场独赢: "1. Halbzeit 1X2",
  下半场独赢: "2. Halbzeit 1X2",
  上半场让球: "1. Halbzeit Handicap",
  下半场让球: "2. Halbzeit Handicap",
  上半场大小球: "1. Halbzeit Ueber/Unter",
  下半场大小球: "2. Halbzeit Ueber/Unter",
  波胆: "Korrektes Ergebnis",
  上半场波胆: "1. Halbzeit Korrektes Ergebnis",
  下半场波胆: "2. Halbzeit Korrektes Ergebnis",
  单双: "Gerade/Ungerade",
  单: "Ungerade",
  双: "Gerade",
  上半场单双: "1. Halbzeit Gerade/Ungerade",
  下半场单双: "2. Halbzeit Gerade/Ungerade",
  上半场总进球: "1. Halbzeit Gesamttore",
  下半场总进球: "2. Halbzeit Gesamttore",
  中场: "Halbzeitpause",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Bitte beachten Sie: Fuer das Foto mit dem Dokument in der Hand schreiben Sie den Text auf ein weisses Blatt Papier und fotografieren Sie dies zusammen mit Ihrem Dokument, wie im Beispiel.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Es wurden kuerzlich viele betruegerische Konten bestraft. Kontaktieren Sie den Kundenservice, wenn Sie glauben, dass Ihr Konto zu Unrecht bestraft wurde.",
  最小下注金额: "Mindesteinsatz",
  参与活动最小下注金额: "Mindesteinsatz fuer die Teilnahme an der Aktion",
  记住密码: "Passwort merken",
  比分: "Ergebnis",
  "您还未登录，请先登录":
    "Sie sind nicht angemeldet. Bitte melden Sie sich zuerst an.",
  立即登录: "Jetzt anmelden",
  下注限额: "Einsatzlimit",
  可赢金额: "Gewinnbarer Betrag",
  闪兑详情: "Details zum Schnellwechsel",
  大小球: "Ueber/Unter",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Aufgrund von Wechselkursschwankungen kann der endgueltige Einsatzbetrag abweichen. Die Bestellung ist massgeblich.",
  开赛时间: "Anpfiffzeit",
  足球收入: "Fussball Einnahmen",
  足球支出: "Fussball Ausgaben",
  活动详情: "Aktionsdetails",
  为世界杯喝彩: "Unterstuetzen Sie die Weltmeisterschaft",
  我的竞猜: "Meine Tipps",
  "竞猜比赛、有机会瓜分*USDT":
    "Tippen Sie auf Spiele und haben Sie Chance auf einen Teil von * USDT",
  "瓜分*USDT": "Teilen Sie * USDT",
  距离活动结束还有: "Noch bis zum Aktionsende:",
  我的门票: "Meine Tickets",
  竞猜结束时间: "Ende der Tippzeit",
  猜比分: "Ergebnis tippen",
  "福利派送中，完成任务即可获取门票":
    "Boni werden verteilt. Schliessen Sie Aufgaben ab, um Tickets zu verdienen.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Schliessen Sie die folgenden Aufgaben ab, um die entsprechende Anzahl an Tickets fuer die Teilnahme am Wettbewerb zu erhalten.",
  时: "Stunde",
  活动: "Aktion",
  竞猜记录: "Tippverlauf",
  结果: "Ergebnis",
  任务: "Aufgabe",
  去邀请: "Einladen",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tippen Sie das Ergebnis jedes Spiels und haben Sie Chance auf einen Teil von $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Fuer das Tippen ist ein Ticket erforderlich. Tickets koennen durch das Abschliessen von Plattformaufgaben verdient werden.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Senden Sie nach einem erfolgreichen Tipp einen Screenshot an den Kundenservice. Sie werden den Bonus auf Ihr Konto ueberweisen, den Sie sofort auszahlen koennen.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Betrug ist verboten. Bei Feststellung verfaellt die Belohnung.",
  "完成任务后，点击咨询客服获得门票。":
    "Klicken Sie nach Abschluss der Aufgaben auf 'Kundenservice kontaktieren', um Tickets zu erhalten.",
  继续猜: "Weiter tippen",
  总单数: "Gesamtzahl der Wetten",
  赛事筛选: "Nach Event filtern",
  球队筛选: "Nach Team filtern",
  总金额: "Gesamtbetrag",
  总流水: "Gesamtumsatz",
  派奖金额: "Ausgezahlter Bonusbetrag",
  下注单数: "Anzahl der Wetten",
  利润: "Gewinn",
  更多福利: "Weitere Boni",
  我的奖金: "Mein Bonus",
  未认证: "Nicht verifiziert",
  总量: "Gesamt",
  或: "oder",
  模拟交易: "Demo-Handel",
  体验账户不可操作: "Nicht verfuegbar auf Demo-Konto",
  世界杯比分竞猜: "WM Ergebnis Tipp",
  "领*USDT起": "Erhalten Sie ab * USDT",
  消息: "Nachrichten",
  滚球: "Live-Wetten",
  是: "Ja",
  不是: "Nein",
  当前余额: "Aktuelles Guthaben",
  KOL招募: "KOL Rekrutierung",
  本月净输赢: "Netto Gewinn/Verlust diesen Monat",
  本月佣金: "Provision diesen Monat",
  佣金比例: "Provisionsanteil",
  活跃人数: "Aktive Benutzer",
  新增下级: "Neue Downlines",
  登录人数: "Eingeloggte Benutzer",
  首存人数: "Ersteinzahler",
  数据分析: "Datenanalyse",
  人数: "Anzahl Personen",
  新注册存款金额: "Einzahlungsbetrag neuer Registrierungen",
  老用户存款金额: "Einzahlungsbetrag bestehender Benutzer",
  首存金额: "Ersteinzahlungsbetrag",
  快捷入口: "Schnellzugriff",
  成员管理: "Mitgliederverwaltung",
  财务报表: "Finanzberichte",
  分红报表: "Dividendenbericht",
  订单记录: "Bestellverlauf",
  VIP专享: "VIP Exklusiv",
  推广工具: "Werbetools",
  计算规则: "Berechnungsregeln",
  账变明细: "Transaktionsdetails",
  成员: "Mitglieder",
  下级概览: "Downline Uebersicht",
  下级成员总计: "Downlines insgesamt",
  本月新增: "Diesen Monat neu",
  本月活跃会员: "Aktive Mitglieder diesen Monat",
  今日活跃会员: "Aktive Mitglieder heute",
  本月有效活跃: "Effektiv aktiv diesen Monat",
  活跃成员占比: "Anteil aktiver Mitglieder",
  本月活跃: "Aktiv diesen Monat",
  今日活跃: "Aktiv heute",
  下级成员: "Downlines",
  会员账号: "Mitgliedskonto",
  统计时间: "Statistikzeitpunkt",
  筛选: "Filtern",
  存款: "Einzahlung",
  取款: "Auszahlung",
  总输赢: "Gesamtgewinn/Verlust",
  是否有效用户: "Aktiver Benutzer?",
  最近登录时间: "Letzte Anmeldung",
  否: "Nein",
  开始时间: "Startzeit",
  结束时间: "Endzeit",
  提取: "Auszahlen",
  总盈亏: "Gesamtergebnis",
  净盈亏: "Nettoergebnis",
  分红: "Dividende",
  概览: "Uebersicht",
  月度详细数据: "Monatliche Details",
  未发放: "Nicht ausbezahlt",
  活跃用户: "Aktive Benutzer",
  有效新增会员: "Effektive neue Mitglieder",
  冲正后净输赢: "Netto Gewinn/Verlust nach Korrektur",
  上月结余: "Saldo Vormonat",
  净输赢: "Netto Gewinn/Verlust",
  "系统每日新加坡时间1:00更新一次报表":
    "Berichte werden taeglich um 01:00 Uhr Singapur-Zeit aktualisiert.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "In den Berichten bedeuten positive Zahlen Gewinn fuer den Partner, negative Zahlen Verlust fuer den Partner.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Provisionsdaten werden taeglich aktualisiert, sind indikativ und stellen keine definitive Auszahlungsgrundlage dar.",
  选择时间: "Zeit auswaehlen",
  足球: "Fussball",
  投注金额: "Einsatzbetrag",
  有效订单: "Gueltige Bestellungen",
  下级账户: "Downline Konto",
  待成交: "In Wartestellung",
  下单金额: "Bestellbetrag",
  订单内容: "Bestellinhalt",
  秒数: "Sekunden",
  联赛: "Liga",
  队伍: "Team",
  比赛时间: "Spielzeit",
  玩法: "Wetttyp",
  等级规则表: "Stufenregeltabelle",
  等级: "Stufe",
  活跃会员: "Aktive Mitglieder",
  最新活跃: "Letzte Aktivitaet",
  额外佣金: "Zusaetzliche Provision",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Monatlich basierend auf den Wachstumsstandards. Es kann nur von einer Stufe profitiert werden.",
  渠道生成: "Kanal generieren",
  创建: "Erstellen",
  渠道名称: "Kanalname",
  注册人数: "Anzahl Registrierungen",
  浏览人数: "Anzahl Aufrufe",
  构建状态: "Baustatus",
  禁用: "Deaktivieren",
  启用: "Aktivieren",
  查看: "Ansehen",
  创建渠道: "Kanal erstellen",
  创建成功: "Erstellung erfolgreich",
  操作成功: "Aktion erfolgreich",
  渠道详情: "Kanaldetails",
  邀请码: "Einladungscode",
  访问人数: "Anzahl Besucher",
  渠道地址: "Kanaladresse",
  我的福利: "Meine Boni",
  充值福利: "Einzahlungsbonus",
  当前流水: "Aktueller Umsatz",
  如何参与: "Wie man teilnimmt",
  币种充值: "Kryptowaehrung Einzahlung",
  充值福利中领取福利: "Bonus bei Einzahlungsbonus erhalten",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Einzahlungsbonus ist freiwillig, gueltig fuer 24 Stunden nach Einzahlung. Nach Erhalt wird die Auszahlung temporaer gesperrt, bis die Umsatzanforderung erfuellt ist.",
  失效日期: "Verfallsdatum",
  "暂无福利领取，充值后领取":
    "Kein Bonus verfuegbar. Nach Einzahlung erhalten.",
  参与: "Teilnehmen",
  充值赠送: "Einzahlungsbonus",
  "领取*%的赠送": "Erhalten Sie *% Bonus",
  去领取: "Erhalten",
  VIP奖励: "VIP Belohnung",
  "当前可领取*USDT，是否确认领取":
    "* USDT verfuegbar zum Erhalten. Bestaetigen?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Nach Erhalt wird die Auszahlung temporaer gesperrt, bis ein Umsatz von * USDT erreicht ist.",
  充值送大礼: "Einzahlungsgeschenk",
  "存入越多，送越多！": "Je mehr Sie einzahlen, desto groesser das Geschenk!",
  无效: "Ungueltig",
  有效: "Gueltig",
  总存金额: "Gesamteinzahlungsbetrag",
  提示: "Hinweis",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positive Zahlen beim Gesamt- und Nettogewinn/Verlust bedeuten Plattformgewinn. Taegliche Daten sind indikativ.",
  "净盈亏：总盈亏-用户返水":
    "Nettoergebnis: Gesamtergebnis - Cashback an Benutzer",
  盈利方: "Gewinnende Partei",
  代理: "Agent",
  客户: "Kunde",
  平局: "Unentschieden",
  平台: "Plattform",
  "已提交审核，请耐心等待": "Zur Pruefung eingereicht. Bitte haben Sie Geduld.",
  充值日期: "Einzahlungsdatum",
  平台本月总输赢: "Plattform Gesamtgewinn/Verlust diesen Monat",
  KOL招募合作: "KOL Rekrutierung Zusammenarbeit",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Die Plattform oeffnet die KOL-Rekrutierung. Mit einem Social-Media-Konto koennen Sie von Dividenden und lebenslangen Einnahmen durch einmalige Kundenwerbung profitieren.",
  级别: "Stufe",
  平台利润返佣: "Plattform Gewinnprovision",
  佣金案例: "Provisionsbeispiel",
  交易项目: "Handelsprodukte",
  "期权交易、合约交易、足球游戏":
    "Optionshandel, Futureshandel, Fussballspiele",
  报名方式: "Anmeldemethode",
  点击KOL招募报名: "Klicken Sie, um sich fuer die KOL-Rekrutierung anzumelden",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Willkommen in unserem Team. Wir unterstuetzen Sie beim Aufbau Ihres eigenen Benutzersystems. Verdienen Sie bis zu *% Provision. Wir freuen uns auf Ihre Teilnahme.",
  输入联系方式: "Kontaktdaten eingeben",
  最低活跃人数: "Mindestanzahl aktiver Benutzer",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Z.B.: Wenn aktive Benutzer diesen Monat ≥ * und Plattform Gesamtgewinn/Verlust ≥ * USDT, fallen Sie unter Stufe * und erhalten *% Provision.",
  比分竞猜: "Ergebnis tippen",
  豪礼相赠: "Grosses Geschenk",
  足球活动: "Fussballaktion",
  圣诞节活动: "Weihnachtsaktion",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Sie haben an einer Aktion teilgenommen. Die Auszahlung ist temporaer gesperrt. Noch * USDT Umsatz erforderlich, um die Sperre aufzuheben.",
  剩余流水: "Restumsatz",
  助力足球: "Unterstuetze Fussball",
  佣金累计: "Provision insgesamt",
  有效投注: "Gueltige Einsaetze",
  今日: "Heute",
  今日返水: "Cashback heute",
  VIP返水: "VIP Cashback",
  返水记录: "Cashback Verlauf",
  成员信息: "Mitgliedsinformationen",
  基本信息: "Basisinformationen",
  钱包余额: "Wallet-Guthaben",
  投注信息: "Einsatzinformationen",
  返水: "Cashback",
  总下注: "Gesamteinsatz",
  今日输赢: "Gewinn/Verlust heute",
  下注动态: "Einsatzaktivitaet",
  返水奖励: "Cashback Belohnung",
  分红金额: "Dividendenbetrag",
  返水支出: "Cashback Ausgabe",
  总返水: "Cashback insgesamt",
  流水总额: "Gesamtumsatz",
  返水总额: "Cashback insgesamt",
  返水详情: "Cashback Details",
  日流水: "Taeglicher Umsatz",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Die Plattform gewaehrt zusaetzliches Cashback basierend auf dem taeglichen Umsatz Ihrer Downlines. Auszahlung taeglich um 00:00 Uhr Singapur-Zeit an das Bounty-Konto.",
  "申请成功，等待审核": "Antrag erfolgreich, warte auf Pruefung",
  "我出本金，盈利共分享": "Ich gebe Kapital, Gewinn wird geteilt",
  最高分红: "Maximale Dividende",
  投资大师比赛: "Master Investor Wettbewerb",
  "我出本金，你盈利": "Ich gebe Kapital, du gewinnst",
  共分享: "Gemeinsam teilen",
  最高分红可得: "Maximal erreichbare Dividende",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exklusiver Willkommensbonus: $* gratis. Nach Erhalt koennen Sie in jedes Projekt investieren. Gewinn ist sofort auszahlbar.",
  报名领取: "Anmelden und erhalten",
  审核驳回: "Pruefung abgelehnt",
  驳回原因: "Grund fuer Ablehnung",
  活动运行周期: "Aktionsdauer",
  "申请成功后起至*天内完成超额收益。":
    "Erzielen Sie innerhalb von * Tagen nach Genehmigung einen ueberschuessigen Ertrag.",
  分红比: "Dividendenquote",
  "*日获得盈利后，可获得*%的收益额。":
    "Nach Erzielung eines Gewinns an Tag * erhalten Sie *% des Ertragsbetrags.",
  参与条件: "Teilnahmebedingungen",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Benutzer aus Russland oder der Tuerkei, die noch nicht teilgenommen haben.",
  计算项目: "Berechnete Produkte",
  "合约、体育、期权": "Futures, Sport, Optionen",
  我的投资: "Meine Investitionen",
  参与天数: "Teilnahmetage",
  累计下注: "Gesamteinsatz",
  累计盈亏: "Gesamtgewinn/Verlust",
  预计可分红: "Erwartete Dividende",
  常见问题: "Haeufig gestellte Fragen (FAQ)",
  什么是平台出资: "Was ist Plattformfinanzierung?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Die Plattform stellt Benutzern aus bestimmten Laendern kostenlose Mittel zur Verfuegung, um in Projekte zu investieren.",
  怎么获取平台出资的福利: "Wie erhalte ich die Plattformfinanzierungsbonus?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Wenn Sie aus einem der festgelegten Laender kommen, klicken Sie auf den Anmeldebutton. Nach Genehmigung werden * USDT auf Ihr Bounty-Konto ueberwiesen, die Sie transferieren koennen, um zu investieren.",
  什么是分红: "Was ist eine Dividende?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividende: Wenn innerhalb der vorgegebenen Zeit der Ertrag 100% erreicht, erhalten Sie 50% des ueberschuessigen Ertrags. Z.B.: Erhalten Sie 100 USDT, erzielen Sie 120% Ertrag, dann sind 20% ueberschuessig.",
  "如何取得分红？": "Wie erhalte ich die Dividende?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Der Aktionszyklus findet alle * Tage statt. Nach Ablauf wird abgerechnet. Bei Erfuellung der Anforderungen wird die Dividende an das Bounty-Konto ausgezahlt. Wenn nicht erfuellt, werden Ihr Ertrag und die Plattformfinanzierung entfernt.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Teilnehmende Konten muessen KYC-verifiziert sein. Nur ein Bonus pro Konto.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC fuer die Teilnahme ist nur fuer festgelegte Laender gueltig. Ueberpruefen Sie, ob Ihr Land mit dem Aktionsland uebereinstimmt.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Nach erfolgreicher Teilnahme wird die Auszahlung temporaer gesperrt, bis die Aktion abgeschlossen ist.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Halten Sie sich an die Aktionsregeln. Bei Betrug oder Missbrauch von Systemfehlern werden alle Vermoegenswerte auf Ihrem Konto dauerhaft eingefroren.",
  平台出资: "Plattformfinanzierung",
  平台出资收回: "Plattformfinanzierung zurueckgenommen",
  投资大师奖励: "Master Investor Belohnung",
  请下载APP添加收款方式:
    "Bitte laden Sie die App herunter, um eine Empfangsmethode hinzuzufuegen",
  请下载APP进行身份验证:
    "Bitte laden Sie die App herunter, um die Identitaetsverifikation durchzufuehren",
  请下载APP参与: "Bitte laden Sie die App herunter, um teilzunehmen",
  技术指标: "Technische Indikatoren",
  主图: "Hauptchart",
  副图: "Nebenchart",
  新注册人数: "Neue Registrierungen",
  老用户存款人数: "Bestehende Benutzer, die einzahlen",
  存款人数: "Anzahl Einzahlungen",
  取款人数: "Anzahl Auszahlungen",
  投注人数: "Anzahl Wetten",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Exklusive Benutzer aus Indonesien, Indien, Bangladesch, die noch nicht teilgenommen haben.",
  市场动态: "Marktdynamik",
  外汇合约: "Forex Futures",
  盈亏比: "Gewinn/Verlust Verhaeltnis",
  委托价: "Orderpreis",
  可用余额: "Verfuegbares Guthaben",
  持仓额: "Positionswert",
  强平价: "Liquidationspreis",
  修改: "Aendern",
  修改价位: "Preis aendern",
  外汇: "Forex",
  外汇账户: "Forex Konto",
  我的交易: "Meine Transaktionen",
  未设置: "Nicht festgelegt",
  超出最大可设数值: "Ueberschreitet den maximal einstellbaren Wert",
  超出最小可设数值: "Unterschreitet den minimal einstellbaren Wert",
  止盈超出最小可设数值:
    "Take-Profit unterschreitet den minimal einstellbaren Wert",
  止损超出最大可设数值:
    "Stop-Loss ueberschreitet den maximal einstellbaren Wert",
  止盈超出最大可设数值:
    "Take-Profit ueberschreitet den maximal einstellbaren Wert",
  止损超出最小可设数值:
    "Stop-Loss unterschreitet den minimal einstellbaren Wert",
  挖矿: "Mining",
  交易账户: "Handelskonto",
  买涨: "Kaufen (Long)",
  买跌: "Verkaufen (Short)",
  请输入正确的银行卡信息: "Bitte geben Sie korrekte Bankkartendaten ein",
  联系在线客服: "Kontaktieren Sie den Live-Kundenservice",
  法币交易请联系在线客服:
    "Bitte kontaktieren Sie fuer Fiat-Handel den Kundenservice",
  提交订单: "Bestellung absenden",
  "支付过程如有疑问,请联系在线客服":
    "Bitte kontaktieren Sie bei Fragen zum Zahlungsvorgang den Kundenservice",
  彩金赠送: "Bonusauszahlung",
  在线客服: "Live-Chat",
  最少投资: "Mindestinvestition",
  "提交时间:": "Einreichungszeit:",
  提现拒绝: "Auszahlung abgelehnt",
  认证拒绝: "Verifikation abgelehnt",
  认证通过: "Verifikation akzeptiert",
  请输入正确的交易额度: "Bitte geben Sie einen gueltigen Handelsbetrag ein",
  最大下注金额: "Maximaleinsatz",
  手机号: "Handynummer",
  邮箱注册: "Mit E-Mail registrieren",
  手机号注册: "Mit Handynummer registrieren",
  查询: "Nachschlagen",
  手机号登录: "Mit Handynummer anmelden",
  邮箱登录: "Mit E-Mail anmelden",
  请输入数量: "Bitte geben Sie Menge ein",
  可用数量: "Verfuegbare Menge",
  钱包登录: "Mit Wallet anmelden",
  请输入正确的邀请码: "Bitte geben Sie einen gueltigen Einladungscode ein",
  "请输入邀请码(必填)": "Bitte geben Sie Einladungscode ein (erforderlich)",
  输入正确的金额: "Bitte geben Sie einen gueltigen Betrag ein",
  法币充值: "Fiat einzahlen",
  卢比充值: "Indische Rupie (INR) einzahlen",
  请输入法币: "Bitte geben Sie Fiat-Betrag ein",
  请输入IFSC: "Bitte geben Sie IFSC-Code ein",
  "银行编码(选填)": "Bankcode (optional)",
  请输入银行编码: "Bitte geben Sie Bankcode ein",
  请输入大于8位数的密码:
    "Bitte geben Sie ein Passwort mit mehr als 8 Zeichen ein",
  添加成功: "Hinzufuegen erfolgreich",
  "60秒": "60 Sekunden",
  "180秒": "180 Sekunden",
  "300秒": "300 Sekunden",
  "2次密码不一致": "Passwoerter stimmen nicht ueberein",
  输入提币数量: "Bitte geben Sie Auszahlungsmenge ein",
  图片格式不正确: "Ungueltiges Bildformat",
  图片大于20M: "Bild ist groesser als 20 MB",
  请设置委托价格: "Bitte legen Sie einen Orderpreis fest",
  输入资金密码: "Bitte geben Sie Vermoegenspasswort ein",
  验证码错误: "Bestaetigungscode falsch",
  充值拒绝: "Einzahlung abgelehnt",
  请输入SSN: "Bitte geben Sie SSN ein",
  结算完成: "Abrechnung abgeschlossen",
  继续下单: "Weiter bestellen",
  限价: "Limit Order",
  买入价格: "Kaufpreis",
  买入量: "Kaufmenge",
  卖出价格: "Verkaufspreis",
  卖出量: "Verkaufsmenge",
  买入: "Kaufen",
  卖出: "Verkaufen",
  订单创建成功: "Bestellung erfolgreich erstellt",
  币币买入支出: "Ausgabe Spot Kauf",
  币币买入支出退还: "Rueckerstattung Ausgabe Spot Kauf",
  币币买入获得: "Erhalt Spot Kauf",
  币币卖出支出: "Ausgabe Spot Verkauf",
  币币卖出支出退还: "Rueckerstattung Ausgabe Spot Verkauf",
  币币卖出获得: "Erhalt Spot Verkauf",
  币币交易手续费: "Spot Transaktionsgebuehr",
  请输入限价: "Bitte geben Sie Limitpreis ein",
  成交: "Ausgefuehrt",
  等待成交: "Warte auf Ausfuehrung",
  交易完成: "Transaktion abgeschlossen",
  被取消: "Storniert",
  交易时间: "Transaktionszeit",
  法币交易: "Fiat Handel",
  法币出售: "Fiat Verkauf",

  两次密码不一致: "Passwoerter stimmen nicht ueberein",
  再次输入账户密码: "Bitte geben Sie das Kontopasswort erneut ein",

  美国: "Vereinigte Staaten",
  韩国: "Suedkorea",
  阿尔巴尼亚: "Albanien",
  津巴布韦: "Simbabwe",
  赞比亚: "Sambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanische Jungferninseln",
  英属处女群岛: "Britische Jungferninseln",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Usbekistan",
  乌拉圭: "Uruguay",
  英国: "Vereinigtes Koenigreich",
  阿拉伯联合酋长国: "Vereinigte Arabische Emirate",
  乌克兰: "Ukraine",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- und Caicosinseln",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Tuerkei",
  突尼斯: "Tunesien",
  特立尼达和多巴哥: "Trinidad und Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Osttimor",
  泰国: "Thailand",
  坦桑尼亚: "Tansania",
  塔吉克斯坦: "Tadschikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syrien",
  瑞士: "Schweiz",
  瑞典: "Schweden",
  斯威士兰: "Swasiland",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanien",
  南非: "Suedafrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonen",
  斯洛文尼亚: "Slowenien",
  斯洛伐克: "Slowakei",
  "圣马丁岛（荷兰部分）": "Sint Maarten (niederlaendischer Teil)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellen",
  塞尔维亚: "Serbien",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabien",
  圣多美和普林西比: "São Tomé und Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "St. Kitts und Nevis",
  圣文森特和格林纳丁斯: "St. Vincent und die Grenadinen",
  圣彼埃尔和密克隆岛: "St. Pierre und Miquelon",
  圣露西亚: "St. Lucia",
  圣基茨和尼维斯: "St. Kitts und Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Russland",
  罗马尼亚: "Rumaenien",
  留尼汪: "Réunion",
  刚果共和国: "Republik Kongo",
  卡塔尔: "Katar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Philippinen",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua-Neuguinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palästina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norwegen",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Neuseeland",
  新喀里多尼亚: "Neukaledonien",
  荷属安德列斯群岛: "Niederlaendische Antillen",
  荷兰: "Niederlande",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolei",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldawien",
  墨西哥: "Mexiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretanien",
  马里亚纳群岛: "Marianen",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Malediven",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nordmazedonien",
  中国澳门: "Macau",
  卢森堡: "Luxemburg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libyen",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lettland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kasachstan",
  约旦: "Jordanien",
  日本: "Japan",
  牙买加: "Jamaika",
  象牙海岸: "Elfenbeinküste",
  意大利: "Italien",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesien",
  印度: "Indien",
  冰岛: "Island",
  匈牙利: "Ungarn",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Groenland",
  希腊: "Griechenland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Deutschland",
  格鲁吉亚: "Georgien",
  冈比亚: "Gambia",
  加蓬: "Gabun",
  法属波利尼西亚: "Französisch-Polynesien",
  法属圭亚那: "Französisch-Guayana",
  法国: "Frankreich",
  芬兰: "Finnland",
  斐济: "Fidschi",
  法罗群岛: "Färöer",
  埃塞俄比亚: "Aethiopien",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Aequatorialguinea",
  萨尔瓦多: "El Salvador",
  埃及: "Aegypten",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikanische Republik",
  多米尼加: "Dominica",
  吉布提: "Dschibuti",
  丹麦: "Daenemark",
  捷克: "Tschechien",
  塞浦路斯: "Zypern",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Kroatien",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elfenbeinküste",
  库克群岛: "Cookinseln",
  科摩罗: "Komoren",
  哥伦比亚: "Kolumbien",
  智利: "Chile",
  乍得: "Tschad",
  中非共和国: "Zentralafrikanische Republik",
  佛得角: "Kap Verde",
  开曼群岛: "Kaimaninseln",
  开普: "Kap",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodscha",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarien",
  文莱: "Brunei",
  巴西: "Brasilien",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnien und Herzegowina",
  玻利维亚: "Bolivien",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgien",
  白俄罗斯: "Weissrussland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesch",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Aserbaidschan",
  奥地利: "Oesterreich",
  澳大利亚: "Australien",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenien",
  阿根廷: "Argentinien",
  安提瓜和巴布达: "Antigua und Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikanisch-Samoa",
  阿尔及利亚: "Algerien",
  中国: "China",
  余额不足: "Unzureichendes Guthaben",
  最低购买: "Mindestkauf",
  最高购买: "Hoechstkauf",
  下单成功: "Bestellung erfolgreich aufgegeben",
  平仓成功: "Position erfolgreich geschlossen",
  请输入正确的平仓数量: "Bitte geben Sie eine gueltige Schliessungsmenge ein",
  加仓成功: "Positionsvergroesserung erfolgreich",
  请输入正确的加仓金额:
    "Bitte geben Sie einen gueltigen Betrag fuer die Positionsvergroesserung ein",
  收藏成功: "Zu Favoriten hinzugefuegt",
  取消收藏成功: "Aus Favoriten entfernt",
  加密币永续: "Kryptowaehrung Perpetual",
  外汇永续: "Forex Perpetual",
  期权账户: "Optionskonto",
  快捷卖币: "Schnell Krypto verkaufen",

  托管资金: "Verwaltetes Vermoegen",
  托管中: "In Verwaltung",
  预计日收益: "Geschaetzter taeglicher Ertrag",
  累计收益: "Gesamtertrag",
  周期: "Laufzeit",
  日收益: "Taeglicher Ertrag",
  限额: "Limit",
  立即托管: "Sofort Vermoegen verwalten lassen",
  "已鎖定 請聯繫客服": "Gesperrt. Bitte kontaktieren Sie den Kundenservice.",
  产品列表: "Produktliste",
  规则: "Regeln",
  创建订单: "Bestellung erstellen",
  产品名称: "Produktname",
  托管周期: "Verwaltungsdauer",
  等级限制: "Stufenbeschraenkung",
  托管金额: "Verwalteter Betrag",
  限额: "Limit",
  余额: "Guthaben",
  购买日: "Kaufdatum",
  起息日: "Verzinsungsbeginn",
  派息时间: "Zinsauszahlungszeit",
  每天: "Taeglich",
  计息结束日: "Zinsende Datum",
  每日收益: "Taeglicher Ertrag",
  预计收益: "Geschaetzter Ertrag",
  "收益将自动发送至您的余额账户;":
    "Ertrag wird automatisch auf Ihr Guthabenkonto gesendet;",
  "您的资金没有任何风险;": "Ihr Vermoegen ist risikofrei;",
  "365*24小时不断地工作;": "Arbeitet 24/7, 365 Tage im Jahr;",
  托管中: "In Verwaltung",
  结束: "Beendet",
  今日收益: "Heutiger Ertrag",
  剩余周期: "Restlaufzeit",
  进行中: "Aktiv",
  已发放: "Ausgezahlt",
  信誉分: "Reputationspunkt",

  复制成功: "Erfolgreich kopiert",
  VIP权益: "VIP-Vorteile",
  旧密码: "Altes Passwort",
  请输入旧密码: "Altes Passwort eingeben",
  "忘记旧密码请联系客服重置。":
    "Wenn Sie Ihr altes Passwort vergessen haben, kontaktieren Sie bitte den Kundendienst, um es zurückzusetzen.",
  去升级: "Upgraden",
  描述: "Beschreibung",
  实际存款金额: "Tatsächlicher Einzahlungsbetrag",
  升级礼金: "Upgrade-Bonus",
  隔夜利息: "Übernachtzinsen (Swap)",
  自动结算: "Automatische Abrechnung",
  等级规则: "Stufenregeln",
  "WEB3.0币持有数据收益": "WEB3.0-Token-Bestandsdaten-Rendite",
  总生产: "Gesamtproduktion",
  有效节点: "Aktive Knoten",
  参与人: "Teilnehmer",
  用户收益: "Benutzerertrag",
  "流动性WEB3.0输出": "Liquiditäts-WEB3.0-Output",
  总资产: "Gesamtvermögen",

  ETHAI持有数据收益: "ETHAI Bsitzdatenertrag",
  AI量化流动性: "AI quantitativi Liquidität",
  现货买入手续费: "Spot-Chaufgebühr",
  现货支出: "Spot-Uusgab",
  现货资金费率: "Spot-Finanzierigsrate",
  现货卖出手续费: "Spot-Verkaufsgebühr",
  现货收入: "Spot-Iinnahme",
  外汇合约支出: "Deviseterminkontrakt-Uusgab",
  外汇合约买入手续费: "Deviseterminkontrakt-Chaufgebühr",
  外汇合约资金费率: "Deviseterminkontrakt-Finanzierigsrate",
  外汇合约卖出手续费: "Deviseterminkontrakt-Verkaufsgebühr",
  外汇合约收入: "Deviseterminkontrakt-Iinnahme",
  理财购买: "Finanzprodukt-Chauf",
  VIP理财日收益: "VIP-Finanzprodukt-Tagesertrag",
  VIP理财隔夜利息: "VIP-Finanzprodukt-Übernachtzins",
  VIP本金返还: "VIP-Rückzahlig vo dr Iilag",
  VIP彩金发放: "VIP-Bonusuussschüttig",
  VIP彩金抵扣: "VIP-Bonusverrechnig",
  隔夜利息: "Übernachtzins",
  设置资产密码: "Vermögenspasswort setze",

  锁仓挖矿: "Gesperrtes Mining",
  一站式理财服务: "Finanzdienstleistungen aus einer Hand",
  产品: "Produkte",
  客服中心: "Kundendienstzentrum",
  贷款: "Kredite",
  挖矿赚不停: "Kontinuierliche Einnahmen durch Mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Gesperrtes Mining bedeutet, dass USDT (USD:1USDT=1USD) an die Hochleistungs-Miningmaschinen der Plattform übertragen werden, um Erträge im Mining-Pool der Plattform zu erzielen.",
  产品优势: "Produktvorteile",
  随存随取: "Jederzeit einzahlen und abheben",
  锁仓周期: "Sperrfrist",
  每日下发: "Tägliche Auszahlung",
  随机空投: "Zufälliger Airdrop",
  "100%资金安全保障": "100% Kapitalsicherheit",
  "100%节假日收益不间断": "100% kontinuierliche Erträge auch an Feiertagen",
  成功锁仓后当天产出: "Erträge ab dem selben Tag nach erfolgreicher Sperrung",
  关于违约金: "Über Vertragsstrafe",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Wenn Sie das Kapital vor Fälligkeit abheben, fällt eine Vertragsstrafe an. Vertragsstrafe = Strafsatz × verbleibende Tage × gesperrter Betrag.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Beispiel: Der Strafsatz beträgt 5 %, es verbleiben 3 Tage, der gesperrte Betrag beträgt 10000U (USDT/USD). Vertragsstrafe = 5%×3×10000=1500U, tatsächlich zurückerstattetes Kapital ist 15000U-1500U.",
  收益计算: "Renditeberechnung",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Die Plattform bietet verschiedene Finanzprodukte für gesperrtes Mining. Die Renditeberechnung lautet wie folgt, zum Beispiel:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Wenn ein Nutzer 10000U (USDT, USD) sperrt und ein 7-Tage-Produkt mit einer täglichen Rendite von 0,7%~1,8% wählt, ergibt sich folgende tägliche Rendite:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Nach 7 Tagen können 490U~1260U an Erträgen erzielt werden. Die Erträge werden täglich ausgezahlt und das Kapital wird bei Fälligkeit automatisch auf Ihr Konto übertragen.",
  正在托管的资金: "Verwaltete Mittel",
  签到: "Check-in",
  锁仓订单: "Gesperrte Aufträge",
  预计今日收益: "Geschätzte heutige Rendite",
  累计收益: "Kumulierte Rendite",
  托管中的订单: "Verwaltete Aufträge",
  单笔最少: "Mindestbetrag pro Auftrag",
  单笔最多: "Maximalbetrag pro Auftrag",
  日收益率: "Tägliche Rendite",
  说明: "Beschreibung",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistik basiert auf GMT+8 Zeit<br>2. Tägliche Rendite wird aus allen abgerechneten Aufträgen zwischen 00:00–23:59 GMT+8 berechnet<br>3. Die Auszahlung erfolgt am nächsten Tag zwischen 00:00–00:10 GMT+8.",
  知道了: "Verstanden",
  锁仓: "Sperren",
  派息时间: "Auszahlungszeit",
  每日: "Täglich",
  托管资金: "Verwaltete Mittel",
  到期返回: "Rückzahlung bei Fälligkeit",
  提前赎回: "Vorzeitige Rückzahlung",
  预计收益: "Erwartete Rendite",
  认购: "Zeichnen",
  热门: "Beliebt",
  数字货币: "Kryptowährungen",
  贵金属: "Edelmetalle",
  大宗商品: "Rohstoffe",
  持仓明细: "Positionsdetails",
  历史明细: "Historie",
  当前价: "Aktueller Preis",
  "↑买涨": "↑ Aufwärts kaufen",
  "↓买跌": "↓ Abwärts kaufen",
  显示全部: "Alle anzeigen",
  买入金额: "Kaufbetrag",
  方向: "Richtung",
  收益: "Gewinn",
  预期收益: "Erwarteter Gewinn",
  估用保证金: "Geschätzte Margin",
  确认下单: "Order bestätigen",
  锁定: "Gesperrt",
  账户总资产: "Gesamtvermögen",
  明细: "Details",
  今日收益: "Heutiger Gewinn",
  仓位保证金: "Positionsmargin",
  持有仓位: "Offene Positionen",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Gesperrter Betrag = Summe aller offenen gesperrten Mining-Aufträge",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistik basiert auf GMT+8<br>2. Tägliche Rendite basiert auf abgerechneten Aufträgen",
  充值方式: "Einzahlungsart",
  银行汇款: "Banküberweisung",
  "银行汇款请联系客服进行操作!":
    "Bitte kontaktieren Sie den Kundendienst für Banküberweisung!",
  提款方式: "Auszahlungsart",
  "银行提款请联系客服进行操作!":
    "Bitte kontaktieren Sie den Kundendienst für Bankauszahlung!",
  资金明细: "Fonddetails",
  提现记录: "Auszahlungshistorie",
  拒绝: "Abgelehnt",
  通过: "Genehmigt",
  拒绝原因: "Ablehnungsgrund",
  消息公告: "Mitteilungen",
  订单: "Bestellungen",
  个人中心: "Persönliches Zentrum",
  "未到期赎回需支付一定的违约金!":
    "Bi früehzitiger Rücklösig muess e Vertragsstraf bezahlt werde.",

  请输入区号: "Bitte gäbed Si d Vorwahl ii",
  "请选择国家/地区": "Bitte wähled Si es Land/e Region us",

  今日开盘: "Heutige Eröffnung",
  昨日收盘: "Gestern Schlusskurs",

  实名认证即送: "Sofort nach der Identitätsprüfung erhalten",
  立即认证: "Jetzt verifizieren",
  新用户礼包: "Geschenkpaket für neue Benutzer",
  完成新人任务领取:
    "Schließen Sie die Aufgaben für neue Benutzer ab und erhalten Sie es",
  认证: "Verifizieren",
  时间周期: "Zeitraum",
  支付金额: "Zahlungsbetrag",
  已平仓: "Geschlossen",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX-Willkommenspaket für neue Benutzer: Jeder Benutzer kann maximal erhalten",
  我已经阅读并同意: "Ich habe gelesen und stimme zu",
  隐私政策: "Datenschutzerklärung",

  放弃奖励离开: "Belohnig ufgeh und verlaa",
  继续注册: "Wiiter registriere",
  分钟: "Minute",

  "请先勾选隐私政策!": "Bitte akzeptieren Sie zuerst die Datenschutzerklärung!",
  添加其他到自选: "Weitere zu Favoriten hinzufügen",

  充值最高可得: "Laden Sie Ihr Guthaben auf und erhalten Sie bis zu 30.000 $.",

  请输入格式正确的手机号: "Bitte geben Sie eine gültige Mobilfunknummer ein.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 瑞士



// WEBPACK FOOTER //
// ./src/lang/rs.js